<div class="d-flex flex-column position-relative">
  <form>
    <input
      #search
      [value]="searchValue"
      (input)="searchChanged($event)"
      [attr.id]="controlId"
      (blur)="searchChanged($event)"
      class="text-field search-text-field"
      [class.disabled]="disabled"
      id="searchBar"
      name="searchBar"
      [disabled]="disabled"
      placeholder="{{ placeholder }}"
      inputmode="numeric"
      type="number" />

    <button
      *ngIf="searchValue"
      type="button"
      class="clear-button"
      (click)="clearSearch(search)"
      aria-label="Clear input"
      i18n-aria-label>
      <img [src]="'assets/icons/grey/X.svg'" alt="Clear" i18n-alt class="clear-icon" />
    </button>
  </form>
</div>
